import React from "react";

import Tooltip from "@material-ui/core/Tooltip";

import ScheduleIcon from '@material-ui/icons/Schedule';
import BlockIcon from '@material-ui/icons/Block';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import Chip from "@material-ui/core/Chip";
import "./style.css";

const lookup = [
  {
    value: 0,
    text: "НАБОР В ГРУППУ"
  },
  {
    value: 1,
    text: "ИДЕТ ОБУЧЕНИЕ"
  },
  {
    value: 2,
    text: "ЗАВЕРШЕНО"
  }
];

function groupStateExcelCell(options, column, gridCell) {
  if (gridCell.value === 0) {
    options.value = "НАБОР В ГРУППУ";
  } else if (gridCell.value === 1) {
    options.value = "ИДЕТ ОБУЧЕНИЕ";
  } else if (gridCell.value === 2) {
    options.value = "ЗАВЕРШЕНО";
  } else {
    options.value = "БЕЗ СТАТУСА";
  }
}

function groupStateCell(config) {
  config.cellRender = GroupStateCell;
  config.dataType = "number";
  config.alignment = "center";
  config.lookup = {
    dataSource: lookup,
    valueExpr: "value",
    displayExpr: "text"
  }
}

const groupSateTextColor = {
  '-1': "#000000",
    '0': "#304967",
    '1': "#85C446",
    '2': "#CACCD1"
  };

const GroupStateCell = (cellData) => {
  const stateId = cellData.value;
  return <GroupStateChip stateId={stateId}/> ;
};

const GroupStateChip = ({stateId}) => {
  switch (stateId) {
    case 0:
      return (
        <div>
          <Tooltip title="НАБОР В ГРУППУ">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[stateId]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<ScheduleIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 1:
      return (
        <div>
          <Tooltip title="ИДЕТ ОБУЧЕНИЕ">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[stateId]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<PlayCircleOutlineIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 2:
      return (
        <div>
          <Tooltip title="ЗАВЕРШЕНО">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[stateId]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<BlockIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    default:
      return (
        <div>
          <Tooltip title="БЕЗ СТАТУСА">
            <Chip color="primary"
                  style={{ "background": "black"}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<HelpOutlineIcon fontSize={"small"}/>}
            />
          </Tooltip>
        </div>
      );
  }
}



export {groupStateCell, groupStateExcelCell, GroupStateChip}
